import { render, staticRenderFns } from "./HelpClassifiesManage.vue?vue&type=template&id=79bdb370&scoped=true"
import script from "./HelpClassifiesManage.vue?vue&type=script&lang=js"
export * from "./HelpClassifiesManage.vue?vue&type=script&lang=js"
import style0 from "./HelpClassifiesManage.vue?vue&type=style&index=0&id=79bdb370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bdb370",
  null
  
)

export default component.exports